import Vue from "vue";
import App from "./App.vue";

// Environment accent color (green=local, blue=staging, purple=prod)
import { applyEnvColor } from "./utils/envColor";
applyEnvColor();

// i18n
import i18n from "./i18n/i18n";

// Font awesome setup
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/css/fontawesome.css";

// Buefy setup
import Buefy from "buefy";
import "buefy/dist/buefy.css";
Vue.use(Buefy, {
  defaultIconPack: "fas",
});

// Clipboard import
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

import { ValidationProvider } from "vee-validate";
import "./vee-validate";
// Register it globally
Vue.component("ValidationProvider", ValidationProvider);

// Momentjs setup
const moment = require("moment-timezone");
Vue.use(require("vue-moment"), {
  moment,
});

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Vuex store
import store from "./store";

// custom css
import "./assets/css/rnd.css";

// Vue Router
import router from "./router";

// Permission control
import "./permission";

// Schedule component
import { SchedulePlugin } from "@syncfusion/ej2-vue-schedule";
Vue.use(SchedulePlugin);

// i18n scheduler component
import { loadCldr, L10n } from "@syncfusion/ej2-base";
import * as localeText from "./i18n/i18n-scheduler.json";
L10n.load(localeText);
loadCldr(
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/de/ca-gregorian.json"),
  require("cldr-data/main/de/numbers.json"),
  require("cldr-data/main/de/timeZoneNames.json")
);
loadCldr(
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/fr/ca-gregorian.json"),
  require("cldr-data/main/fr/numbers.json"),
  require("cldr-data/main/fr/timeZoneNames.json")
);
loadCldr(
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/it/ca-gregorian.json"),
  require("cldr-data/main/it/numbers.json"),
  require("cldr-data/main/it/timeZoneNames.json")
);

new Vue({
  comments: true,  // @todo only for dev
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js